/* eslint-disabled */

export default class ParrainageExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
